import { FuseAuthUser } from '@fuse/core/FuseAuthProvider/types/FuseAuthUser';
import { FuseSettingsConfigType } from '@fuse/core/FuseSettings/FuseSettings';
import { PartialDeep } from 'type-fest';

export type DNSUser = {
	role: string;
	registrar_trading_name: string;
	first_name: string;
	last_name: string;
	telephone: string;
	registrar_street: string;
	registrar_street2: string;
	registrar_street3: string;
	registrar_city: string;
	registrar_code: string;
	registrar_country: string;
	registrar_province: string;
	email: string;
	verified: boolean;
	registrered: boolean;
	recovery_required: boolean;
	recovery_error: string | null;
	recovery_parameters: {
		registrar_trading_name: string;
		registrar_country: string;
		registrar_province: string;
		registrar_city: string;
		registrar_code: string;
		registrar_street: string;
		registrar_street2: string;
		registrar_street3: string;
		email: string;
	} | null;
};

export enum Role {
	Onboarding = 'Onboarding',
	Admin = 'Admin',
	Technical_Support = 'Technical Support',
	Billing = 'Billing',
	Marketing = 'Marketing',
	Abuse_Contact = 'Abuse Contact',
	Domain_Manager = 'Domain Manager',
	Primary = 'Primary',
	Billing_Contact = 'Billing Contact',
	Primary_Contact = 'Primary Contact'
}

/**
 * The type definition for a user object.
 */
export type User = FuseAuthUser & {
	roles: Role[] | null;
	displayName: string;
	photoURL?: string;
	email?: string;
	shortcuts?: string[];
	settings?: PartialDeep<FuseSettingsConfigType>;
	loginRedirectUrl?: string; // The URL to redirect to after login.
	data?: DNSUser;
	epp_id: string;
};
